// extracted by mini-css-extract-plugin
module.exports =  {"popper":"_0d624b9a27--popper--KAN9G"};